import { render, staticRenderFns } from "./PatientDashboard.vue?vue&type=template&id=483093da&scoped=true&"
import script from "./PatientDashboard.vue?vue&type=script&lang=js&"
export * from "./PatientDashboard.vue?vue&type=script&lang=js&"
import style1 from "./PatientDashboard.vue?vue&type=style&index=1&id=483093da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483093da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
